"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var convertEmToPixel = function convertEmToPixel(emValue) {
  var fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  return emValue * fontSize;
};

var _default = convertEmToPixel;
exports["default"] = _default;